import React from "react";
import { PRODUCTS } from "./productsData";
import { saveSelectedProduct } from "./session";


import "./products-grid.css";

/**
 * If you're using react-router:
 *   const navigate = useNavigate();
 *   onSelect => navigate("/apply")
 *
 * Here we accept onStartApply as prop to keep it framework-agnostic.
 */
export default function ProductsGrid({ onStartApply }) {
  const handleSelect = (product) => {
    saveSelectedProduct(product);
    onStartApply?.(product);
  };

  return (
    <section className="pgWrap" id="products">
      <h2 className="pgTitle">4 Amazing POS Solutions With 0%</h2>

      <div className="pgGrid">
        {PRODUCTS.map((p) => (
          <article key={p.id} className="pgCard" onClick={() => handleSelect(p)}>
            <div className="pgImageWrap">
              <img className="pgImage" src={p.imageUrl} alt={p.name} />
            </div>

            <div className="pgDivider" />

            <div className="pgBody">
              <h3 className="pgName">
                {p.name} <span className="pgPlus">+ </span>
                <span className="pgZero">0%</span>{" "}
                <span className="pgSub">{p.subtitle}</span>
              </h3>

              <p className="pgDesc">{p.description}</p>

              <ul className="pgBullets">
                {p.bullets.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>

              <div className="pgBestFits">
                <div className="pgBestTitle">Best fits for</div>
                <ul className="pgBestList">
                  {p.bestFits.map((bf, i) => (
                    <li key={i}>{bf}</li>
                  ))}
                </ul>
              </div>

              <div className="pgFooter">
                <div className="pgPrice">
                  <div className="pgJustFor">Just for</div>
                  <div className="pgPriceRow">
                    <span className="pgNow">
                      ${p.priceNow.toFixed(2)}
                      <span className="pgMo">/mo</span>
                    </span>
                    <span className="pgWas">
                      ${p.priceWas.toFixed(2)}
                      <span className="pgMo">/mo</span>
                    </span>
                  </div>
                </div>

                <button className="pgCta" >
                  GET STARTED <span className="pgArrow">›</span>
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}